/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */

/**
 * Whether to block around the conflicting bookings or cancel them.
 */
export type ConflictResolutionDtoMode = typeof ConflictResolutionDtoMode[keyof typeof ConflictResolutionDtoMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConflictResolutionDtoMode = {
  SPLIT: 'SPLIT',
  CANCEL_BOOKINGS: 'CANCEL_BOOKINGS',
} as const;
